import React from 'react';
import { Animated, Easing, View } from 'react-native';

export default class Throb extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      opacityAnimate: new Animated.Value(0.3)
    }
  }

  startAnimating = () => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(this.state.opacityAnimate, {
          toValue: 0.8,
          duration: 2000,
          useNativeDriver: false,
          easing: Easing.inOut(Easing.sin)
        }),
        Animated.timing(this.state.opacityAnimate, {
          toValue: 0.3,
          duration: 2000,
          useNativeDriver: false,
          easing: Easing.inOut(Easing.sin)
        })
      ]),
    ).start()
  }

  componentDidMount() {
    this.startAnimating();
  }

  render() {
    if (!!(this.props.disabled)) {
      return (
        <View>
          {this.props.children}
        </View>
      )
    }
    return (
      <Animated.View style={{opacity: this.state.opacityAnimate}}>
        {this.props.children}
      </Animated.View>
    );
  }
}
